import type { SxProps, Theme } from '@mui/material';

const splitContainer = (isMobile: boolean): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  gap: 2,
  minHeight: 360,
});

const leftPanel: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};

const rightPanel: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

const selectedList: SxProps<Theme> = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  flex: 1,
  overflow: 'auto',
  maxHeight: 320,
};

const emptyState: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  minHeight: 120,
  color: 'text.secondary',
};

export const multiStyles = {
  splitContainer,
  leftPanel,
  rightPanel,
  selectedList,
  emptyState,
} as const;
